
import { defineComponent } from "vue";
import { useRouter } from "vue-router";
import { routeNames } from "@/router";
import LoginForm from "@/components/LoginForm.vue";
import Footer from "@/components/Footer.vue";

export default defineComponent({
  name: "Login",
  components: {
    LoginForm,
    Footer,
  },
  setup() {
    const router = useRouter();
    const toTemplateList = () => {
      router.push({ name: routeNames.SelectTemplate });
    };
    const toSaveDataList = () => {
      router.push({ name: routeNames.SelectEditData });
    };
    return {
      toTemplateList,
      toSaveDataList,
    };
  },
});
